import {Input} from "semantic-ui-react";
import * as React from "react";
import {
    CategoryTextKey,
    FlagKey,
    OptionTypeViewKey,
    StatusColumnKey
} from "../../../../../views/OptionsView/OptionColumns";
import PortalDropdownFilter from "../../dropdowns/PortalDropdownFilter";
import {InputOnChangeData} from "semantic-ui-react/dist/commonjs/elements/Input/Input";
import {TDerivate} from "../../../VirtualizedTableInterfaces";
import {OptionTypeColumnKey} from "../../../../../views/BaseOptionsView/BaseOptionsColumns";

interface VirtualizedTableHeaderFilterProps {
    t: reactI18Next.TranslationFunction;
    columnKey: string;
    isDropdown: boolean;
    dropdownFilters?: {
        [key: string]: Set<string>,
    };
    filterValue: {[key: string]: any};
    onFilterChange: (key: string, value: string | boolean | TDerivate | Set<string>) => void;
}

const VirtualizedTableHeaderFilter: React.SFC<VirtualizedTableHeaderFilterProps> = (props: VirtualizedTableHeaderFilterProps) => {
    const {dropdownFilters, filterValue, columnKey, onFilterChange, isDropdown, t} = props;

    if(isDropdown && dropdownFilters &&
        (columnKey === OptionTypeViewKey
            || columnKey === CategoryTextKey
            || columnKey === StatusColumnKey
            || columnKey === OptionTypeColumnKey
            || columnKey === FlagKey
        )) {
        return (
            <PortalDropdownFilter
                options={dropdownFilters[columnKey]}
                value={filterValue[columnKey]}
                onChange={(value: Set<string>) => onFilterChange(columnKey, value)}
                t={t}
            />
        );
    } else {
        return (
            <Input
                fluid={true}
                value={filterValue[columnKey] || ""}
                input={{id: columnKey}}
                onChange={(e: React.SyntheticEvent<HTMLElement>, data: InputOnChangeData) => onFilterChange(columnKey, data.value as string)}
            />
        );
    }
};

export default VirtualizedTableHeaderFilter;



// WEBPACK FOOTER //
// ./src/components/Table/components/headerComponents/virtualizedTableHeaderCell/VirtualizedTableHeaderFilter.tsx